<script lang="ts">
  import SectionSalarie from '@/generated/sections/SectionSalarie.vue';
  import { Fiches, Sections } from '@/generated/classes/AppSchema';
  import { storeSalarie, storeContact } from '@/generated/stores';
  import DialogHubManager from '@/framework/dialog/helpers/DialogHubManager';
  import Salarie from '@/generated/classes/Salarie';
  import { defineComponent } from "vue";
  import Contact from '@/generated/classes/Contact';
  import { storeSession } from '@/generated/stores';

  export default defineComponent({
    components: {},
    extends: SectionSalarie,
    mounted() {
      if (this.fiche == Fiches.SALARIE || this.fiche == Fiches.SALARIE_ABSTRACT) {
        DialogHubManager.waitAnswer('createSalarie', this.createSalarie);
      }
    },
    computed: {
      contact(): Salarie {
        return this.editSalarie;
      },
      connectedUserId(): number {
        const user = storeSession.connectedUser;
        return user ? user.id : 0;
      },
      identReadOnly(): boolean {
        return !this.editSalarie.firstConnexion && this.connectedUserId != this.editSalarie.id;
      },
      numero: {
        get(): string {
          this.readOnlyMap.set("MAIL", this.cloneSalarie.id > 0 && this.cloneSalarie.numero != this.editSalarie.numero);
          return this.editSalarie.numero;
        },
        set(value: string) {
          this.editSalarie.numero = value;
          this.fieldUpdated('NUMERO', value);
        }
      },
      mail: {
        get(): string {
          this.readOnlyMap.set("NUMERO", this.cloneSalarie.id > 0 && this.cloneSalarie.mail != this.editSalarie.mail);
          return this.editSalarie.mail;
        },
        set(value: string) {
          this.editSalarie.mail = value;
          this.fieldUpdated('MAIL', value);
        }
      }
    },
    methods: {
      createSalarie(obj: unknown) {
        const salarie = obj as Salarie;
        this.editSalarie = storeSalarie.getSalarie(salarie.id);
        this.$emit('updated', this.editSalarie);
        this.displayMap.clear();
      },
      showIdentifiant(): boolean {
        return this.editSalarie.id < 0 &&
          (this.fromSection == Sections.CONNEXION ||
            this.fromSection == Sections.CONTRAT_SALARIE ||
            this.fiche == Fiches.PROFIL ||
            this.fiche == Fiches.SALARIE ||
            this.fiche == Fiches.SALARIE_ABSTRACT);
      },
      fieldUpdated(field: string, value: unknown): void {
        const user = storeSession.connectedUser;

        if (field == "MAIL") {
          this.readOnlyMap.set("NUMERO", this.cloneSalarie.id > 0 && this.cloneSalarie.mail != this.editSalarie.mail);
        } else if (field == "NUMERO") {
          this.readOnlyMap.set("MAIL", this.cloneSalarie.id > 0 && this.cloneSalarie.numero != this.editSalarie.numero);
        }
      },
      readOnly(value: string): boolean {
        let res = false;
        if (!this.editSalarie.canUpdate) {
          return true;
        }
        if (this.readOnlyMap.size == 0) {
          this.readOnlyMap.set("CIVILITE_ID", false);
          this.readOnlyMap.set("PRENOM", false);
          this.readOnlyMap.set("NOM", false);
          this.readOnlyMap.set("MAIL", this.identReadOnly);
          this.readOnlyMap.set("NUMERO", this.identReadOnly);
          this.readOnlyMap.set("IDENTIFIANT", false);
        }
        const readOnly = this.readOnlyMap.get(value);
        if (readOnly != undefined) {
          res = readOnly;
        }
        return res;
      },

      isDisplayed(value: string): boolean {
        let res = true;
        if (this.displayMap.size == 0) {
          const requiredAttributs = this.getRequiredAttributs();
          this.displayMap.set("CIVILITE_ID", this.requiredMissing(requiredAttributs, "CIVILITE_ID") || (!this.showIdentifiant() && !!this.fiche));
          this.displayMap.set("PRENOM", true);
          this.displayMap.set("NOM", true);
          this.displayMap.set("MAIL", this.requiredMissing(requiredAttributs, "MAIL") || (!this.showIdentifiant() && !!this.fiche));
          this.displayMap.set("NUMERO", this.requiredMissing(requiredAttributs, "NUMERO") || (!this.showIdentifiant() && !!this.fiche));
          this.displayMap.set("IDENTIFIANT", this.requiredMissing(requiredAttributs, "IDENTIFIANT") || this.showIdentifiant());
        }
        const display = this.displayMap.get(value);
        if (display != undefined) {
          res = display;
        }
        return res;
      },
      sectionSave(): void {
        if (this.editSalarie.id <= 0) {
          this.save();
          this.readOnlyMap.set("NUMERO", false);
          this.readOnlyMap.set("MAIL", false);
          this.displayMap.clear();
        }
        else if (this.cloneSalarie.mail == this.editSalarie.mail &&
             this.cloneSalarie.numero == this.editSalarie.numero) 
        {    
            // Ni mail ni téléphone modifiés (ex. seul le métier) :
            // passer par le flux salarié qui persiste emploiId
          this.save();
        } else {
          Contact.save(this.editSalarie).then((res) => {
            this.updated = false;
            this.readOnlyMap.set("NUMERO", this.identReadOnly);
            this.readOnlyMap.set("MAIL", this.identReadOnly);
          });
        }
      }
    }
  })

</script>
